import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { ShippingRegionDetails } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShippingRegionDetailService extends TmsWebBaseEditCreateService<
  ShippingRegionDetails,
  ShippingRegionDetails
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ShippingRegionDetail', $localize`Shipping Region Detail`, httpService, notificationService);
  }

  getForShippingRegionHeader(id: string): Observable<ShippingRegionDetails[]> {
    return this.httpService.get<ShippingRegionDetails[]>(`${this.apiUrl}/GetForShippingRegionHeader?id=${id}`);
  }
}
